import React from 'react';
import { IntlProvider } from 'react-intl';
import { BrowserRouter as Router } from 'react-router-dom';
import PropTypes from 'prop-types';

const InitScreen = (props) => {
  const {
    LoadingComponent,
    locale,
    messages
  } = props;

  return (
    <IntlProvider locale={ locale } messages={ messages[locale] } wrapRichTextChunksInFragment>
      <Router>
        <LoadingComponent />
      </Router>
    </IntlProvider>
  );
};

InitScreen.propTypes = {
  LoadingComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  locale: PropTypes.string,
  messages: PropTypes.any
};

export default InitScreen;
